import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CompanyCorporateCharterDto } from '@interfaces/corporate-charter/responses/corporate-charter.response';
import { VaultDateTimePipe } from '@shared/pipes/vault-date-time.pipe';
import { CharterCapitalCardComponent } from '@features/dashboard/company/corporate-charter/components/charter-capital-card/charter-capital-card.component';
import { CharterClausesCardComponent } from '@features/dashboard/company/corporate-charter/components/charter-clauses-card/charter-clauses-card.component';
import { CharterCompanyCardComponent } from '@features/dashboard/company/corporate-charter/components/charter-company-card/charter-company-card.component';
import { CharterGovernanceCardComponent } from '@features/dashboard/company/corporate-charter/components/charter-governance-card/charter-governance-card.component';
import { CharterHoldersCardComponent } from '@features/dashboard/company/corporate-charter/components/charter-holders-card/charter-holders-card.component';

/**
 * Aba "Contrato vigente": os cartões da empresa,
 * do capital, dos sócios, da administração e das cláusulas, e o rodapé com quando o vigente foi montado e conferido
 * com a Receita.
 */
@Component({
  selector: 'app-charter-current-view',
  imports: [
    VaultDateTimePipe,
    CharterCompanyCardComponent,
    CharterCapitalCardComponent,
    CharterHoldersCardComponent,
    CharterGovernanceCardComponent,
    CharterClausesCardComponent,
  ],
  templateUrl: './charter-current-view.component.html',
  styleUrl: './charter-current-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharterCurrentViewComponent {
  readonly charter = input.required<CompanyCorporateCharterDto>();
}
